import { useConsent } from '../../../analytics'
import s from './CookieConsent.module.css'

export default function CookieConsent() {
  const { consentStatus, grantConsent } = useConsent()

  if (consentStatus !== 'pending') return null

  return (
    <div className={s.banner}>
      <div className={s.content}>
        <h3 className={s.title}>
          <span className={s.emoji} aria-hidden="true">
            🍪
          </span>
          Трошки про печиво
        </h3>
        <p className={s.text}>
          Наш сайт, як і будь-яка порядна кав&apos;ярня, не обходиться без печива. Тільки наше —
          цифрове: файли cookie. Вони допомагають нам пам&apos;ятати
          ваш кошик, розуміти, яка кава вам до смаку, і робити сайт зручнішим з кожним візитом.
          Жодних крихт на клавіатурі — обіцяємо.
        </p>
      </div>
      <div className={s.buttons}>
        <button type="button" className={s.acceptButton} onClick={grantConsent}>
          Гаразд, смачного!
        </button>
        <a
          href="/privacy-policy"
          className={s.linkButton}
          target="_blank"
          rel="noopener noreferrer"
        >
          Дізнатися більше
        </a>
      </div>
    </div>
  )
}
